import VDivider from './VDivider.vue';

export { VDivider };
export default VDivider;
